import React, { memo } from 'react'
import PropTypes from 'prop-types'

import styles from './myName.module.scss'

function MyName(props) {
  const { name, description } = props
  return (
    <div className={styles.wrapper}>
      <img className={styles.photo} src="images/my-photo.jpeg" alt="my-perso" />
      <div className={styles.name}>{name}</div>
      <div className={styles.description}>{description}</div>
    </div>
  )
}

MyName.defaultProps = {
  name: '',
  description: '',
}

MyName.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
}

export default memo(MyName)
